import {
  ListItem,
  ListItemRightData,
  ListItemRightTitleDescIcon,
  Typography,
} from '@components/ui';
import { Measure2Outlined } from '@icon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IDetailRowProps } from '../../../../types/life-id';
import { TVitalHistoryMeta } from '../../../../types/vital-history';

interface RowProps
  extends IDetailRowProps,
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  meta: TVitalHistoryMeta;
  style?: React.CSSProperties;
}

type TState = 'normal' | 'raised' | 'lowered' | 'high' | 'low';

function mapStateToColor(state: TState | string) {
  switch (state) {
    case 'normal':
      return '#3BD382';
    case 'raised':
    case 'lowered':
      return '#F48D09';
    case 'high':
    case 'low':
      return '#EA4961';
    default:
      return '#ffffff';
  }
}

function calculateStatus(states: (TState | string)[]) {
  let warn = 0;

  for (const status of states) {
    if (status === 'normal') {
      continue;
    } else if (status === 'raised' || status === 'lowered') {
      warn += 1;
    } else {
      return 'attention';
    }
  }

  return warn > 0 ? 'warn' : undefined;
}

const Row = (
  { chartProps, meta, time, createdTime, value, source, ...rest }: RowProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  return (
    <ListItem
      {...rest}
      ref={ref}
      right={
        <ListItemRightData
          left={
            <>
              <ListItemRightData.TitleDesc
                title={
                  <>
                    {value}{' '}
                    <Typography as="span" display="body2" variant="default">
                      <FormattedMessage id={(meta as TVitalHistoryMeta).units} />
                    </Typography>
                  </>
                }
              />
              <ListItemRightData.TachometerBar
                values={chartProps.degrees}
                pointerColors={chartProps.graphStates.map(mapStateToColor)}
                barStyle={{ width: 120 }}
                preset={chartProps.oneSidedRange ? 'lifeIdPositive' : 'lifeId'}
                status={calculateStatus(chartProps.graphStates)}
              />
            </>
          }
        />
      }
    >
      <ListItemRightTitleDescIcon
        title={time}
        description={createdTime}
        Icon={source === 'Client' ? Measure2Outlined : undefined}
      />
    </ListItem>
  );
};

export default React.memo(React.forwardRef(Row));
